/* eslint-disable react/prop-types */
import React from 'react';
import { Descriptions, Image } from 'antd';

import { SectionCard } from '../../../../ui';

import ProcessStepsView from '../ProcessStepsView';
import styles from '../index.less';

/**
 * 成员详情 · 概览信息
 * ------------------------------------------------------------------
 * 2026-09-11：介绍 / 背景墙 / 荣誉证书并入本页签。
 * 卡片头部已有头像 + 花名 + 类型标签，这里不再重复。
 *
 * 2026-09-17 从 coachProfile/index.jsx 抽出（该文件 1765 行）：
 * 本页签原本占 213 行，抽成独立组件后容器只留一个引用；
 * 顺手把 13 处内联样式与 13 个字面量色值改为类 + token。
 *
 * 2026-09-17 再调（用户反馈）：成员头部（header）与「入驻流程」（steps）
 * 也**渲染在本组件的卡片内部** —— 之前放在卡外的裸节点里，看起来像两块
 * 与概览无关的内容 ✗，现在与概览内容同卡、用一条分隔线分开。
 *
 * @param header 成员头部节点（头像/花名/类型 + POWER 链接），由 MemberTab 传入
 * @param steps  入驻流程步骤数据
 */
export const OverviewSection = ({ coachData, coachInfo, header, steps }) => (
  <SectionCard title="概览信息">
    <div className={styles.headBlock}>
      {header}
      {steps && steps.length ? (
        <ProcessStepsView steps={steps} title="入驻流程" />
      ) : null}
    </div>
    <div className={styles.introWrap}>
      {[['介绍', coachData?.personalSignature || '--']].map(([k, v]) => (
        <div key={k} className={styles.introRow}>
          <span className={styles.introLabel}>{k}</span>
          <span className={styles.introValue}>{v}</span>
        </div>
      ))}

      <div className={`${styles.introRow} ${styles.introRowSplit}`}>
        <span className={styles.introLabel}>背景墙</span>
        <Image.PreviewGroup>
          <div className={styles.wallWrap}>
            {(coachData?.bgUrls || []).length ? (
              (coachData.bgUrls || []).slice(0, 6).map((u, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <Image
                  key={i}
                  width={148}
                  height={108}
                  src={u}
                  className={styles.imgCoverSm}
                />
              ))
            ) : (
              <span className={styles.emptyText}>暂无背景墙图片</span>
            )}
          </div>
        </Image.PreviewGroup>
      </div>

      <div className={`${styles.introRow} ${styles.introRowSplit}`}>
        <span className={styles.introLabel}>荣誉证书</span>
        <Image.PreviewGroup>
          <div className={styles.wallWrap}>
            {(coachData?.certificates || []).length ? (
              (coachData.certificates || []).map((c, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={i} className={styles.certItem}>
                  {c.picture ? (
                    <Image
                      src={c.picture}
                      width={148}
                      height={108}
                      className={styles.imgCoverSm}
                    />
                  ) : (
                    <div className={styles.certPlaceholder} />
                  )}
                  <div className={styles.certName} title={c.name}>
                    {c.name}
                  </div>
                </div>
              ))
            ) : (
              <span className={styles.emptyText}>暂无荣誉证书</span>
            )}
          </div>
        </Image.PreviewGroup>
      </div>
    </div>

    <div className={styles.sectionTitle}>成员信息</div>
    <Descriptions
      labelStyle={{ width: '180px' }}
      contentStyle={{ width: '200px' }}
      className={styles.descBlock}
      column={3}
      size="small"
      bordered
    >
      <Descriptions.Item label="APP最近登录设备：">
        <span>{coachInfo?.tenantProfile?.deviceModel || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="操作系统版本：">
        <span>{coachInfo?.tenantProfile?.deviceOs || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="地理位置：">
        <span>{coachInfo?.tenantProfile?.address || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="设备PUSH开关：">
        <span>{coachInfo?.tenantProfile?.pushSwitch ? '已开启' : '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="APP最近访问时间：">
        <span>{coachInfo?.tenantProfile?.appAccessLatestTime || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="天天私教小程序：">
        <span>{coachInfo?.tenantProfile?.ttsjAccessLatestTime || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="抖音健身大人物：">
        <span>
          {coachInfo?.tenantProfile?.bigbangDouyinAccessLatestTime || '--'}
        </span>
      </Descriptions.Item>
    </Descriptions>

    <div className={`${styles.sectionTitle} ${styles.sectionTitleGap}`}>
      互动数据
    </div>
    <Descriptions
      labelStyle={{ width: '180px' }}
      contentStyle={{ width: '200px' }}
      className={styles.descBlock}
      column={3}
      size="small"
      bordered
    >
      <Descriptions.Item label="已加企微：">
        <span>{coachInfo?.alreadyAddWxUser || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="专属服务群：">
        <span>{coachInfo?.serviceGroup || '--'}</span>
      </Descriptions.Item>
      <Descriptions.Item label="专属商家群：">
        <span>{coachInfo?.coachGroup || '--'}</span>
      </Descriptions.Item>
    </Descriptions>
  </SectionCard>
);

export default OverviewSection;
